import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getParishesFromReducer = get('territories.parishes');

export const getIsLoading = state => fromReducer.getIsLoading(getParishesFromReducer(state));

export const getParishes = state => fromReducer.getParishes(getParishesFromReducer(state));
